import type { CustomFieldDefinition } from '../../orders/api/intakeApi'

/**
 * Client-side validation mirroring the backend's `validateFieldDefinitions`.
 * Duplicate keys WITHIN the list are rejected; under the template-copy model a
 * merchant's list is independent of the solution template, so there is no
 * cross-list key-collision rule. Returns an array of error strings (empty = valid).
 */
export function validateFieldDefinitions(fields: CustomFieldDefinition[]): string[] {
  const errors: string[] = []
  const keys = new Set<string>()

  for (let i = 0; i < fields.length; i++) {
    const f = fields[i]
    const prefix = `Field #${i + 1}`

    if (!f.key || !f.key.trim()) {
      errors.push(`${prefix}: key is required`)
    } else if (keys.has(f.key)) {
      errors.push(`${prefix}: duplicate key "${f.key}"`)
    } else {
      keys.add(f.key)
    }

    if (!f.label || !f.label.trim()) {
      errors.push(`${prefix} ("${f.key || '?'}"): label is required`)
    }

    const validTypes = ['text', 'textarea', 'number', 'select', 'multiselect', 'date', 'file', 'url', 'boolean'] as const
    if (!validTypes.includes(f.type as typeof validTypes[number])) {
      errors.push(`${prefix} ("${f.key || '?'}"): unknown type "${f.type}"`)
    }

    if (f.type === 'select' || f.type === 'multiselect') {
      const opts = f.validation?.options
      if (!opts || opts.length === 0) {
        errors.push(`${prefix} ("${f.key || '?'}"): ${f.type} fields must have at least one option`)
      }
    }
  }

  return errors
}
